import { sendWebsocketMessage } from '../../../../../../App';
/**
 * This is seperate than a softorder. this is more hardlined to
 * changing configurations of the tradeplan/tactics itself,
 * whereas the softorders are more directed at what composes the current exit price.
 * This probably doesnt make a lot of sense, and it would be easier to show.
 * @param {*} pluginType
 * @param {*} pluginJsonDetails
 * @param {*} pluginName
 * @param {*} tradePlanId
 */
export function updateTradePlanConfiguration(
  //tactic, setup, setup filter
  tradePlanId, field, details
) {
  const msg = {
    messageType: 'updateTradePlan',
    field: 'updateTradePlanConfiguration',
    tradePlanId,
    value: {
      field,
      details,
    },
  };
  sendWebsocketMessage(msg);
}
